define([
    'jquery',
    './globals',
    './helpers/console',
], function ($, globals, console) {
    'use strict';

    var isValidEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    var autoExpand = function (field) {

        // Reset field height
        field.style.height = 'inherit';

        // Get the computed styles for the element
        var computed = window.getComputedStyle(field);

        // Calculate the height
        var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
            + parseInt(computed.getPropertyValue('padding-top'), 10)
            + field.scrollHeight
            + parseInt(computed.getPropertyValue('padding-bottom'), 10)
            + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

        field.style.height = height + 'px';
    };

    var init_shipping_method = function() {
        $(document).off('change', "[name='shipping_method']");
        $(document).on('change', "[name='shipping_method']", function() {
            var $radio = $(this);
            var radioId = $radio.prop('id');

            $('.js_shipping_method_blocks').slideUp(300, function() {
                $('.' + radioId).slideDown();
            });
        });
    };

    var init_invoice_details = function() {
        $(document).off('change', "[name='invoice_type']");
        $(document).on('change', "[name='invoice_type']", function() {
            var $radio = $(this);
            var radioId = $radio.prop('id');

            $('.js_invoice_details_blocks').slideUp(300, function() {
                $('.' + radioId).slideDown();
            });
        });
    };

    var init = function () {

        var $form = $('.js_form_checkout');
        if ($form.length === 0) {
            return;
        }

        init_shipping_method();
        init_invoice_details();

        // autoExpand the text area as they type
        document.addEventListener('input', function (event) {
            if (event.target.tagName.toLowerCase() !== 'textarea') return;
            autoExpand(event.target);
        }, false);

        var $form_parent = $form.parent('.form__parent'),
            url = $form.attr('action'),
            hasError = false;

        // csrf
        var $tokenInputField = $form.find('#token'),
            postTokenName = $tokenInputField.attr('name'),
            postTokenValue = $tokenInputField.val();


        var $names = $form.find('[name=names]'),
            $email = $form.find('[name=email]'),
            $phone = $form.find('[name=phone]'),
            $consent = $form.find('[name=consent]'),
            $submit = $form.find('button');

        $form.on('focus', 'input, textarea', function () {
            var $this = $(this);
            $this.removeClass('field_error');
        });

        $form.on('change', '[name=consent]', function () {
            $('.consent_wrap').removeClass('field_error');
        });


        $(document).off('submit', '.js_form_checkout');
        $(document).on("submit", '.js_form_checkout', function(event) {
            event.preventDefault();

            $form.find('.error').remove();
            $form.find('.has-error').removeClass('has-error');
            $form.find('.field_error').removeClass('field_error');
            hasError = false;

            var data = $form.serializeArray();
            data.push({name: "submit", value: $submit.val()});
            console.log(data);

            $submit.addClass('loading');
            $form.find('.form-control').prop("disabled", true);

            if (!$consent.is(':checked')) {
                hasError = true;
                $('.consent_wrap').addClass('field_error');
            }

            if ($names.val() === '') {
                hasError = true;
                $names.addClass('field_error');
            }

            if ($phone.val() === '') {
                hasError = true;
                $phone.addClass('field_error');
            }

            if (!isValidEmail($email.val())) {
                hasError = true;
                $email.addClass('field_error');
            }

            if (hasError) {
                $submit.removeClass('loading');
                $form.find('.form-control').prop("disabled", false);
                globals.goToByScroll($form.find('.field_error').first());

                return false;
            }

            $.ajax({
                beforeSend: function (request) {
                    request.setRequestHeader('X-' + postTokenName, postTokenValue);
                },
                url: url,
                method: 'POST',
                cache: false,
                data: $.param(data),
                dataType: 'json'
            })
                .done(function (json) {
                    console.log(json);

                    $form.find('.error').remove();
                    $form.find('.has-error').removeClass('has-error');
                    $form.find('.field_error').removeClass('field_error');

                    $form.find('.form-control').prop("disabled", false);
                    $submit.prop('disabled', false);
                    $submit.removeClass('loading');

                    if (json.error) {
                        $.each(json.errors, function (field, msg) {
                            if (field === 'form') {
                                $form.prepend("<span class='error'>" + msg + "</span>");
                                globals.goToByScroll($form_parent);
                            } else {
                                var $field = $('#' + field);
                                $field.addClass('field_error');
                                $field.after("<span class='error'>" + msg + "</span>");
                                globals.goToByScroll($field);
                            }
                        });
                    } else {
                        if (json.message) {

                            $('.shopping_cart_mini__count').html('0');

                            $('.order_cart_wrap').slideUp(400, function() {
                                $(this).empty();
                            });

                            $('.order_totals__wrap').slideUp(400, function() {
                                $(this).empty();
                            });

                            $form_parent.slideUp(400, function () {
                                $form_parent.html(json.message);
                                $form_parent.slideDown(300);
                            });
                        }
                    }

                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    $form.find('.form-control').prop("disabled", false);

                    $submit.prop('disabled', false);
                    $submit.removeClass('loading');

                    alert(textStatus, errorThrown)
                });
        });
    };

    return {
        init: init
    };
});
